module.exports = __webpack_public_path__ + "img/77305.a1a37b3a.svg";